const catalogsInfo = [{
    link: 'https://drive.google.com/file/d/1rW6mgKoCcZwoIonRt_QM6rsLT6OAagnl/view',
    text: 'Catalogo de Dama Ecónomico'
},
{
    link: 'https://drive.google.com/file/d/1L_Odfa-1KjzLOq4ini0B3NTuzMg5coQQ/view',
    text: 'Catalogo de Dama Básico'
},
{
    link: 'https://drive.google.com/file/d/1K7lcADhMlmQ9MpRkGUDMkQ04NhDjtvnM/view',
    text: 'Catalogo de Dama Ribetes'
},

{
    link: 'https://drive.google.com/file/d/1hOj76odhjIWmhcEnwsOp9wL3DDwEimCc/view',
    text: 'Catalogo de Blusones'
},
{
    link: 'https://drive.google.com/file/d/1b8vvHFnPSTrISRbObD-jpjWAW9ohSwLr/view',
    text: 'Catalogo de Caballero'
},
{
    link: 'https://drive.google.com/file/d/1gPSMIUqf_ziBU8jU2L7qasGKwy6FZ06c/view',
    text: 'Catalogo Infantil'
}
]

export default catalogsInfo;
